var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgShieldCheckLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5L10.1084 1.41299C10.3372 1.46383 10.5 1.66674 10.5 1.90109V6.89445C10.5 7.8975 9.9987 8.8342 9.1641 9.3906L6 11.5L2.8359 9.3906C2.00131 8.8342 1.5 7.8975 1.5 6.89445V1.90109C1.5 1.66674 1.66277 1.46383 1.89154 1.41299L6 0.5ZM6 1.52439L2.5 2.30217V6.89445C2.5 7.56315 2.8342 8.1876 3.3906 8.55855L6 10.2982L8.6094 8.55855C9.1658 8.1876 9.5 7.56315 9.5 6.89445V2.30217L6 1.52439ZM8.2262 4.11092L8.9333 4.81802L5.7513 8L3.63 5.8787L4.3371 5.17155L5.75095 6.58545L8.2262 4.11092Z",
    fill: "#486280"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShieldCheckLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield-check-line.47f43e9c.svg";
export { ForwardRef as ReactComponent };